import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "CRS",
  title: defineMessage({
    id: "fig.finance.aid.CRS.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.CRS.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.CRS.source",
    defaultMessage: ``,
  }),
};
